import { SPORT_BY_ID } from "../constants/sportWorkspace";
import { writeStoredSport } from "./sportWorkspace";
import { createWidgetId } from "./dashboardLayout";

export const presentationName = ({ displayName, username } = {}) => {
  const named = String(displayName || "").trim();
  return named || username || "";
};

export const shouldShowTrivia = (trivia) =>
  Boolean(trivia && Number(trivia.totalGamesPlayed) > 0);

export const shouldShowCommunity = (community) =>
  Boolean(
    community &&
      (Number(community.publishedRosters) > 0 ||
        Number(community.matchups) > 0 ||
        Number(community.debatesCreated) > 0)
  );

export const hasTriviaPlaque = (plaque) =>
  Boolean(plaque && Number(plaque.totalGamesPlayed) > 0);

export const hasTriviaMedals = (medals) =>
  Array.isArray(medals) && medals.length > 0;

export const hasCommunityWins = (record) => Number(record?.wins) > 0;

export const pinnableSuggestions = (suggestions = []) =>
  suggestions.filter((row) => row && row.alreadyPinned !== true && row.widget);

export const appendPinnedWidget = (layout, widget) => [
  ...(Array.isArray(layout) ? layout : []),
  {
    ...widget,
    id: widget?.id || createWidgetId(),
  },
];

export const suggestionKeyForPlayer = (sport, playerId) =>
  `player:${sport}:${playerId}`;

export const suggestionKeyForCompare = (sport, playerIds = []) =>
  `compare:${sport}:${[...playerIds].map(String).sort().join(",")}`;

export const applyPreferredSportFromUser = (user, storage) => {
  if (!SPORT_BY_ID[user?.preferredSport]) return;
  writeStoredSport(user.preferredSport, storage);
};
